export class ImageCategory{
    id : number = 0;
    name : string = "" //カテゴリー名
    isLeaf : boolean = false //子供を持っていればfalse、持っていなければtrue
    children : this[] = [] //子供を持っていればいれてください
    isSelected : boolean = false //選択されたものだけtrue
    isExpanded : boolean = false //選択状態にあるカテゴリーの親とその親はtrue、それ以外false
    isVisible : boolean = false //とりあえず常にtrue
    isDraggable : boolean = false //常にfalse
    isSelectable : boolean = false //常にtrue
    data : any[] = [] //空の配列をください
}